import React, { Component, Fragment } from 'react'
import Link from "react-router-dom/es/Link";
import LoadMask from 'Utils/LoadMask/LoadMask';
import CardForm from '../../../Utils/Cards/CardForm';
import { esImagen } from '../../../../../utility/utils'
import { Image } from 'antd';
import { SWALMOD, EN_EDICION, EN_REVISION, VALIDADA, RECHAZADA } from "../../../../../utility/constants"
const alerta_img = require('assets/img/icons/alert.svg');


export default class VerValidado extends Component {
    componentWillMount() {
        if (this.props.match.params.id) {
            this.props.leer(this.props.match.params.id);
        }
    }

    envioARevision = () => {

        SWALMOD.fire({
            title: '¿Enviar publicidad a revisión?',
            text: '¡Se le enviara una notificación al administrador para indicarle que revise la publicidad!',
            showCancelButton: true,
            confirmButtonText: '¡Sí, aprobar!',
            cancelButtonText: 'No, cancelar',
            reverseButtons: true,
            imageUrl: alerta_img,
            imageAlt: 'Alerta',
            imageWidth: 90,
        }).then((result) => {
            if (result.value) {
                this.props.envioARevision(this.props.match.params.id)
            }
        });
    };

    render() {
        const { item = "", loader, me = "" } = this.props; //Constantes

        const {
            estado_publicidad = 0,
            justificacion_rechazo = ""
        } = item
        const { pubicidad_transmision_validacion = true } = me

        return (
            <div className="mb-4 col-12 mt-4">
                <CardForm col={8} titulo="DETALLE PUBLICIDAD">
                    <LoadMask loading={loader} blur>
                        <div className="col-12 form-group m-auto px-0 px-sm-4">

                            <div className="row">
                                <label htmlFor="licencia_img" className="m-0 text-sm">ESTADO: PUBLICIDAD
                                    {estado_publicidad == EN_EDICION ? " EN EDICIÓN" :
                                        estado_publicidad == EN_REVISION ? " EN REVISIÓN" :
                                            estado_publicidad == VALIDADA ? " VALIDADA" :
                                                estado_publicidad == RECHAZADA ? " RECHAZADA" :
                                                    ""}
                                </label>
                            </div>
                            {estado_publicidad == RECHAZADA &&
                                <div className="d-flex flex-column flex-sm-row align-items-center">
                                    <img src={alerta_img} alt="Alerta" width={25} height={20} className="mr-2  blink-danger" />
                                    <span className="bold rojo">{justificacion_rechazo}</span>
                                </div>
                            }

                            <div className="text-center mb-3 mt-4" />
                            <div className="row my-n2">
                                <div className="react-bs-container-header" style={{ height: 20 }} />
                            </div>
                            {item && item.detalle_publicidad && item.detalle_publicidad.length > 0 && item.detalle_publicidad.map((detalle, index) => {
                                const {
                                    imagen = null,
                                    // texto = "",
                                } = detalle
                                return (
                                    <div className="row border-publicidad p-3 px-2 px-sm-5 d-flex align-items-center" key={index}>
                                        <div className="col-12 px-0 text-center ">
                                            {imagen &&
                                                <Image
                                                    src={imagen}
                                                    // height={80}
                                                    alt="Imagen de la publicidad"
                                                    className="img-fluid image-puntero"
                                                    fallback="data:image/png;base64,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"
                                                />
                                            }
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                        <div className="d-flex flex-wrap justify-content-center align-items-center mt-5 px-md-0">
                            <div className="col-sm-12 col-md-5 col-lg-5 col-xl-4 col-12 mb-3">
                                <Link className="btn btn-dark btn-block" to="/publicidades">Regresar</Link>
                            </div>
                            {!pubicidad_transmision_validacion && (estado_publicidad == EN_EDICION) &&
                                <div className="col-sm-12 col-md-5 col-lg-5 col-xl-4 col-12 mb-3">
                                    <button type="button" className="btn btn-primary btn-block" onClick={this.envioARevision}>Enviar a validación</button>
                                </div>
                            }
                        </div>
                    </LoadMask>
                </CardForm>
            </div>
        )
    }
}
